import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSlider from './components/HeroSlider';
import FeaturedCategories from './components/FeaturedCategories';
import BestSellers from './components/BestSellers';
import NewArrivals from './components/NewArrivals';
import CustomerReviews from './components/CustomerReviews';
import Newsletter from './components/Newsletter';
import AboutSection from './components/AboutSection';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white" dir="rtl">
      <Navbar />
      <HeroSlider />
      <AboutSection />
      <FeaturedCategories />
      <BestSellers />
      <NewArrivals />
      <CustomerReviews />
      <Newsletter />
      <Footer />
    </div>
  );
};

export default HomePage;